<script setup>
import { ref, computed, onMounted, onUnmounted, useTemplateRef } from "vue";
import { useStore } from "vuex";

import Tweezer from 'tweezer.js'
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { easeOutQuad } from 'ez.js'

const store = useStore();

const currentList = ref([]);
const isMounted = ref(false);
const isGlanceDown = ref(false);

const renderedResults = computed(() => {
    if(isMounted.value)
        return store.getters.results
    else
        return []
});

onMounted(async () => {
    isMounted.value = true;

    if(store.getters.results.length > 0){
        currentList.value = store.getters.results;
    } 
    window.addEventListener("left-scroll", (event) => {
        if(isMounted.value) store.commit("isModuleOpen", false);
    });

    scrollRef.value.addEventListener('focusin', (event) => {
        console.log("height: " + scrollRef.value.scrollHeight)
        console.log("height: " + Math.abs(scrollRef.value.scrollTop))
    });

    //await new Promise(resolve => setTimeout(resolve, 200));
    //isGlanceDown.value = true;
    //await new Promise(resolve => setTimeout(resolve, 3000));
    //isGlanceDown.value = false;
})

onUnmounted(() => {
    isMounted.value = false;
})

const scrollRef = useTemplateRef('scroll-area')
const isScrollAtTop = computed(() => {
    if(scrollRef.value){
        return scrollRef.value.scrollTop === 0;
    } else {
        return false;
    }
});
const isScrollAtBottom = computed(() => {
    if (scrollRef.value) {
        return Math.abs(scrollRef.value.scrollHeight - scrollRef.value.clientHeight - scrollRef.value.scrollTop) <= 1;
    } else {
        return false;
    }
});


function onBeforeEnter(el) {
    if (el.dataset.index < 6) {
        el.style.opacity = 0;
        el.style.transform = `translateX(-20px)`
    } else {
        el.style.opacity = 1;
        el.style.transform = `translateX(0px)`
    }
}

async function onEnter(el, done) {
    if (el.dataset.index < 6) {
        await new Promise(resolve => setTimeout(resolve, el.dataset.index * 200))
        new Tweezer({
            start: 0,
            end: 1,
            duration: 600,
            easing: easeOutQuad
        })
            .on('tick', value => {
                el.style.opacity = value
                el.style.transform = `translateX(${(1 - value) * -20}px)`
            })
            .on('done', done)
            .begin() // this fires the tweening
    } else {
        done();
    }

}

const handleScroll = (event) => {
    console.log("scrolling")
}

// TODO: not sure if these have to be hardcoded or if we can get them with API (in case links change)
const seriesBadges = ref({
  1: "https://www.nascar.com/wp-content/uploads/sites/7/2023/05/10/nascar_cup_series_logo.svg",
  2: "https://www.nascar.com/wp-content/uploads/sites/7/2025/09/30/NOAPS-Primary_FullColor-RGB.svg",
  3: "https://www.nascar.com/wp-content/uploads/sites/7/2023/05/10/nascar_craftsman_truck_series_logo.svg"
});

</script>

<template>
    <div class = "flex-descending-column">
        <div class = "glance-down-area flex-center">
            <transition name = "glance-fade">
                <div class = "glance-down-container flex-center" v-if = "isGlanceDown">
                    Glance down for live map
                </div>
            </transition>
        </div>
        <div class = "leaderboard">
            <div class = "modal-header">
                <img :src="seriesBadges[store.getters.raceMetadata ? store.getters.raceMetadata.series_uid : 1]">
                <div class = "header-right">
                    <div class = "header-sub" >{{store.getters.raceMetadata?.name}}</div>
                    <span class = "header-sub" v-if = "store.getters.currentStage != null">
                    {{store.getters.raceMetadata?.ttl_laps - store.getters.lapsRemaining}} <span class = "header-subtext">of</span> {{store.getters.raceMetadata?.ttl_laps}} <span class = "header-subtext">|</span> Stage {{store.getters.currentStage}}
                    </span>
                </div>
            </div>
            <div class = "modal-content flex-descending-column" ref = "scroll-area" @scroll="handleScroll">
                <div class = "loading-area" v-if = "renderedResults.length == 0">
                    <LoadingSpinner></LoadingSpinner>
                </div>
                <TransitionGroup
                    :css="false"
                    @before-enter="onBeforeEnter"
                    @enter="onEnter"
                    name = "basic-list"
                >
                    <button class = "leaderboard-item focusable" v-for="(result, index) in renderedResults"
                        :data-index="index" :key="result.no">
                        <div class = "left-section">
                            <div class = "list-text">
                                {{result.ps}}.
                            </div>
                            <img class = "car-logo" :src="`https://cf.nascar.com/data/images/carbadges/1/${result.no}.png`" alt="">
                            <div class = "driver-name" v-if = "result.drv != null">
                                {{result.drv.l_nm}}
                            </div>
                            <div class = "driver-name" v-else-if = "result.riData != null && store.getters.allDrivers[result.riData.NASCARDriverID] != null">
                                {{store.getters.allDrivers[result.riData.NASCARDriverID].Last_Name}}
                            </div>
                        </div>

                        <div class = "right-section">
                            <div class = "time" v-if = "result.diff_tm > 0">
                                <!-- TODO Time gaps = 0 for lapped vehicles -->
                                -{{(result.diff_tm / 1000).toFixed(3)}}
                            </div>
                        </div>
                    </button>
                </TransitionGroup>
            </div>
        </div>
    </div>
  
</template>

<style lang="scss" scoped>

@import '../sass/GlobalClasses';
@import '../sass/Settings';

.glance-fade-enter-active, .glance-fade-leave-active
{
  transition: all .3s ease;
}

.glance-fade-enter-from
{
  opacity: 0;
  transform: scaleX(0.2);
}

.glance-fade-leave-to
{
  opacity: 0;
  transform: scaleX(0.2);
}

.glance-down-area{
    position: fixed;
    width: 100%;
    height: vw(44);
    left: 0;
    top: 0;
}

.glance-down-container{
    position: relative;
    width: fit-content;
    padding: vw(20);
    height: vw(44);
    border-radius: vw(5);
    background-color: #4F4F4F;
    font-weight: 400;
}

.leaderboard{
    padding: vw(20);
    overflow: hidden;
    position: fixed;
    left: vw(66);
    top: vw(66);
    right: vw(66);
    bottom: vw(66);
    border-radius: vw(5);
    background: linear-gradient(132.96deg, rgba(199, 199, 199, 0.5) -27.09%, rgba(79, 79, 79, 0.5) 27.74%, rgba(129, 129, 129, 0.5) 99.43%);
}

.loading-area{
    margin-top: vw(85);

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .sponsored-by{
        position: relative;
        width:vw(76);
        height: auto;
        margin-top: vw(20);
    }

    .sponsored-image {
        position: relative;
        width: vw(116);
        height: auto;
        margin-top: vw(8);
    }
}

.modal-header{
    width: 97%;
    padding: 0;
    margin: 0;
    margin-bottom: vw(15);
}

.header-subtext{
    font-weight: 400;
    font-size: vw(20);
}

.leaderboard-item:focus{
    &:before {
        border-radius: vw(7);
        inset: vw(-1);
        border: solid vw(3) #0000;
        background: white border-box;
    }
}

.leaderboard-item:nth-child(odd) {
    background-color: #A2A2A2;
}

.leaderboard-item:nth-child(even) {
    background-color: #313131;
}

.leaderboard-item{
    position: relative;
    width: vw(420);
    min-height: vw(64);
    height: vw(64);
    font-size: vw(23);
    color: white;
    border-radius: vw(5);
    margin-bottom: vw(10);
    border: none;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: vw(30);

    &:before {
        position: absolute;
        inset: vw(0);
        z-index: 1;
        border-radius: vw(5);
        border: solid vw(1) #0000;
        background: linear-gradient(10deg, #FFFFFF, #4c4c4c) border-box;
        --lyr: conic-gradient(red 0 0);
        /* any kind of gradient that's opaque everywhere */
        /* exclude padding-box (that is, mask out everything but the border area) */
        mask: var(--lyr) padding-box exclude, var(--lyr);
        content: ''
    }

    .left-section{
        position: relative;
        height: 100%;
        width: contain;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-family: 'GoogleSansFlex';
        font-weight: 300;
        font-size: vw(24);

        .list-text{
            position: relative;
        }

        .car-logo{
            position: relative;
            width: auto;
            height: vw(40);
            margin-left: vw(18);
        }

        .driver-name{
            position: relative;
            margin-left: vw(12);
        }
    }

    .right-section{
        position: absolute;
        height: 100%;
        width: contain;
        right: 0;
        top: 0;

        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        font-family: 'GoogleSansFlex';
        font-weight: 400;
        font-size: vw(24);

        .time{
            position: relative;
            width: auto;
            margin-right: vw(25);
            font-size: vw(24);
            font-weight: 400;
        }
    }
}


</style>
